import styled from "@emotion/styled";
import MUISkeleton from "@mui/material/Skeleton";
import { use100vh } from "react-div-100vh";
import isMobile, { isTablet } from "src/helpers/isMobile";
import { Breakpoints, mq } from "src/helpers/mediaQuery";

const SkeletonList = styled(MUISkeleton)`
  width: 300px;
  height: 100%;
  border-radius: 28px;
`;

const SkeletonExam = styled(MUISkeleton)`
  height: 100%;
  max-width: 1000px;
  border-radius: 28px;
  width: 100%;
  margin: 0 55px 0;

  ${mq(Breakpoints.sm)} {
    margin: 0;
  }
`;

const Header = styled(MUISkeleton)`
  width: 100%;
  margin: 4px 0 12px;
  border-radius: 28px;
`;

const Controller = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
`;

const Container = styled("div")`
  display: flex;
  height: ${({ height }) => height}px;
  padding: 20px;

  > div:first-of-type {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${mq(Breakpoints.sm)} {
    flex-direction: column;
    padding: 4px;
  }
`;

function Exam() {
	const height = use100vh();

	if (isMobile()) {
		return (
			<Container height={height}>
				<Header variant="rounded" height={40} />
				<div>
					<SkeletonExam variant="rounded" />
				</div>
				<Controller>
					<SkeletonList variant="rounded" height={45} width={160} />
					<SkeletonList variant="rounded" height={45} width={160} />
				</Controller>
			</Container>
		);
	}

	if (isTablet()) {
		return (
			<Container height={height}>
				<SkeletonExam variant="rounded" />
			</Container>
		);
	}

	return (
		<Container height={height}>
			<SkeletonList variant="rounded" />
			<div>
				<SkeletonExam variant="rounded" />
			</div>
		</Container>
	);
}

export default Exam;
